import React, { useState, useRef } from 'react';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import MDInput from "components/MDInput";
import TextField from '@mui/material/TextField';
import MDButton from "components/MDButton";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
//import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import FormField from "layouts/pages/account/components/FormField";
import MDEditor from "components/MDEditor";
import MDDatePicker from "components/MDDatePicker";
import MDTypography from "components/MDTypography";
import Autocomplete from "@mui/material/Autocomplete";
import MapSelect from './map';
import MDSnackbar from "components/MDSnackbar";
import config from "../../../config";
import { useNavigate,useLocation } from "react-router-dom";

// Import cluster data (array of { id: number, name: string })
import clustersData from '../../map/data/response/cluster_response.json';


const Interventions = () => {
    const navigate = useNavigate();
  const [island, setIsland] = useState('');
  const [programmed, setProgrammed] = useState('');
  const [category, setCategory] = useState('');
  const [subCategory, setSubCategory] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [code, setCode] = useState('');
  const [timerange, setTimeRange] = useState({ from: '', to: '' });
  const [cluster, setCluster] = useState(''); // stores cluster id
  const [position, setPosition] = useState(null);//[0,0]
  const [fileName, setFileName] = useState(''); // file name
  const [status, setStatus] = useState(''); // Κατάσταση παρέμβασης
  const [description, setDescription] = useState(''); // Σύντομη Περιγραφή/Παρατηρήσεις
  const fileInputRef = useRef(null);


  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);



  const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
  const API_URL = config.MAP_MATCHING_API_URL;


  function bringSuccessNotification() {
    return (
      <MDSnackbar
        color="success"
        icon="check"
        title="Ατυχήματα Ειδοποίηση"
        content="Επιτυχής εγγραφή παρέμβασης"
        dateTime={new Date().toLocaleTimeString()}
        open={successSB}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
        bgWhite
      />
    );
  }

  function bringErrorNotification() {
    return (
      <MDSnackbar
        color="error"
        icon="warning"
        title="Παρεμβάσεις Ειδοποίηση"
        content="Αποτυχία εγγραφής παρέμβασης"
        dateTime={new Date().toLocaleTimeString()}
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
        bgWhite
      />
    );
  }
  // Build dropdown options from cluster JSON: label "name-id", value id
  const clusterOptions = (clustersData || []).map((c) => ({
    id: c.id,
    name: `cluster-${c.id}`,
  }));

  const fields = {
    programmed: [{ id: 1, name: "Προγραμματισμένο" }, { id: 2, name: "Μη προγραμματισμένο" }],
    category: [{ id: 1, name: "Κλειστός δρόμος" }, { id: 2, name: "Κλειστή λωρίδα" }, { id: 3, name: "Οδικές εργασίες" }, { id: 4, name: "Οδικά έργα" }, { id: 5, name: "Φραγμός δρόμου" }, { id: 6, name: "Πλημμυρισμένος δρόμος" }, { id: 7, name: "Ατύχημα δρόμου" }, { id: 8, name: "Συμβάν δρόμου" }],
    type_of_code: [{ id: 1, name: "Εκτεταμένης κλίμακας" }, { id: 2, name: "Διαγράμμιση οδοστρώματος" }, { id: 3, name: "Αργά κινούμενες εργασίες συντήρησης" }, { id: 4, name: "Γρήγορες εργασίες συντήρησης" }, { id: 5, name: "Βραχυπρόθεσμες εργασίες σταθερού πεδίου" }, { id: 6, name: "Εργασίες καθαρισμού οδού" }, { id: 7, name: "Εργασίες χειμερινής συντήρησης" }],
    cluster: [{ id: 1, name: "Cluster 1" }, { id: 1, name: "Cluster 2" }],
    status: [
      { id: 1, name: "Πρόταση" },
      { id: 2, name: "Μελέτη" },
      { id: 3, name: "On going" },
      { id: 4, name: "Κλειστό" }
    ],
    islands:[
  { "id": 1, "name": "Ρόδος" },
  { "id": 2, "name": "Κως" },
  { "id": 3, "name": "Κάλυμνος" },
  { "id": 4, "name": "Λέρος" },
  { "id": 5, "name": "Κάρπαθος" },
  { "id": 6, "name": "Κάσος" },
  { "id": 7, "name": "Πάτμος" },
  { "id": 8, "name": "Αστυπάλαια" },
  { "id": 9, "name": "Νίσυρος" },
  { "id": 10, "name": "Τήλος" },
  { "id": 11, "name": "Σύμη" },
  { "id": 12, "name": "Χάλκη" },
  { "id": 13, "name": "Λειψοί" },
  { "id": 14, "name": "Μεγίστη" },
  { "id": 15, "name": "Αγαθονήσι" },
  { "id": 16, "name": "Σύρος" }
]

  }

  const categorySub = [
    {
      id: 1,
      name: "Συντήρηση",
      subcategories: [
        { id: 1, name: "Εργασίες συντήρησης κατακόρυφης/οριζόντιας σήμανσης" },
        { id: 2, name: "Κλάδεμα φυτεύσεων" },
        { id: 3, name: "Διατάξεις ανάσχεσης ταχύτητας (ανακλαστήρες, ακουστικές λωρίδες)" },
        { id: 4, name: "Τοποθέτηση πεζοφάναρου/Αναλάμπων κίτρινος φανός πεζών" },
        { id: 5, name: "Ηλεκτρονικός εξοπλισμός Διαβάσεων" },
        { id: 6, name: "Αποκατάσταση φθορών οδοστρώματος" },
        { id: 7, name: "Άλλες παρεμβάσεις συντήρησης" }
      ]
    },
    {
      id: 2,
      name: "Έργο",
      subcategories: [
        { id: 8, name: "Κυκλικός Κόμβος" },
        { id: 9, name: "Νησίδα" },
        { id: 10, name: "Διάβαση πεζών" },
        { id: 11, name: "Υπέργεια διάβασης" },
        { id: 12, name: "Διαπλάτυνση δρόμου" },
        { id: 13, name: "Κατασκευή εσοχής" },
        { id: 20, name: "Άλλες υποδομές" },
        { id: 21, name: "Φωτεινή σηματοδότηση" },
        { id: 22, name: "Κυκλοφοριακές ρυθμίσεις" },
        { id: 23, name: "Άλλη κατασκευή" },
      ]
    },
    {
      id: 3,
      name: "Τεχνολογική παρέμβαση",
      subcategories: [
           { id: 16, name: "Αισθητήρες κυκλοφορίας" },
        { id: 17, name: "Έξυπνη σηματοδότηση" },
        { id: 18, name: "Πινακίδες μεταβλητών μηνυμάτων" },
        { id: 19, name: "Ηλεκτρονικές πινακίδες your speed is" },
         { id: 24, name: "Εφαρμογή C-ITS" },
        { id: 25, name: "Άλλη τεχνολογία" }

      ]
    },    {
      id: 4,
      name: "Αστυνόμευση",
      subcategories: [
        { id: 14, name: "Κάμερες αστυνόμευσης" },
        { id: 15, name: "Κάμερες παρακολούθησης κυκλοφορίας" },
        { id: 26, name: "Κάμερες εποπτείας" }

      ]
    }
  ];



  const handleInputChange = (field, value) => {
    if (field === "category") {
      setCategory(value.id);
      setSubCategory(''); // Reset υποκατηγορία όταν αλλάζει κατηγορία
      setSelectedCategory(value); // Set the selected category
    } else if (field === "subCategory") {
      setSubCategory(value?.id || '');
    } else if (field === "status") {
      setStatus(value?.id || '');
    } else if (field === "description") {
      setDescription(value || '');
    } else if (field === "cluster") {
      setCluster(value?.id ?? '');
    } else if (field === "island") {
  setIsland(value?.id || '');
    } 
    else {
      console.error("Unknown field: ", field);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    setFileName(file.name);
  };

  const handleImportClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleSubmit = async () => {
    // Απλό validation – προαιρετικό
    if (!category || !subCategory || !position || !status) {
      console.warn("Missing required fields:", {
        category,
        subCategory,
        position,
        cluster,
        status,
      });
      return;
    }

    // position = [lat, lng] αλλά το API θέλει [lng, lat]
    //const [lat, lng] = position;

    const payload = {
      // εδώ στέλνεις τα ids όπως τα έχεις στο state
      islandId: island,         // από το dropdown
      categoryId: category,         // π.χ. "maintenance"
      subcategoryId: subCategory,
      statusId: status,             // π.χ. "sub1"
      nameEl: "Παρέμβαση", // δεν έχεις πεδίο τίτλου, οπότε reuse την περιγραφή ή βάλε default
      scheduleId: 1,                // TODO: αν αργότερα έχεις schedule, βάλε το πραγματικό id
      clusterId: cluster !== '' ? Number(cluster) : null,
      description: description || "",
      geometry: {
         type: "Point",
        coordinates: [[position[1], position[0]]]
      }, // [lng, lat]
    };

    try {
      console.log("Submitting intervention payload:", payload);
      console.log("Submitting intervention payload:", JSON.stringify(payload));
      const url = `${API_URL}/interventions`;

      await axios.post(url, payload, {
        headers: {
          'X-API-Key': API_TOKEN,
          'Content-Type': 'application/json'
        }
      });
      setSuccessSB(true);
      setTimeout(() => {
        navigate("/list/interventions"); // adjust if your route differs
      }, 3000);
    } catch (error) {
      console.log(error);
      setErrorSB(true);
    }
  };

  return (
    <DashboardLayout>
      <Grid container spacing={3} sx={{ minHeight: '500px' }}>
        <Grid item xs={12} md={5}>
          <Card id="accident-form" sx={{ overflow: "visible" }}>
            <MDBox p={3}>
              <MDTypography variant="h5">Εισαγωγή Παρεμβάσεων</MDTypography>
            </MDBox>
            <MDBox compoent="form" pb={3} px={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <MDTypography variant="button">Νησί</MDTypography>
                  <Autocomplete
                    value={fields.islands.find((i) => i.id === island) || null}
                    options={fields.islands}
                    getOptionLabel={(o) => o.name}
                    onChange={(e, v) => handleInputChange("island", v)}
                    renderInput={(p) => <MDInput {...p} variant="standard" />}
                  />
                </Grid>
                {/* Category */}
                <Grid item xs={12}>
                  <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                    Κατηγορία
                  </MDTypography>
                  <Autocomplete
                    value={categorySub.find((type) => type.id === category) || null}
                    options={categorySub}
                    getOptionLabel={(option) => option.name}
                    onChange={(e, selectedOption) => handleInputChange("category", selectedOption)}
                    renderInput={(params) => (<MDInput {...params} variant="standard" />)}
                  />
                </Grid>

                {/* Subcategory */}
                {selectedCategory && (
                  <Grid item xs={12}>
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Υποκατηγορία
                    </MDTypography>
                    <Autocomplete
                      value={selectedCategory.subcategories.find((sub) => sub.id === subCategory) || null}
                      options={selectedCategory.subcategories}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, selectedOption) => handleInputChange("subCategory", selectedOption)}
                      renderInput={(params) => <MDInput {...params} variant="standard" />}
                    />
                  </Grid>
                )}
                {/* Status */}
                
                <Grid item xs={12}>
                <MDTypography
                  component="label"
                  variant="button"
                  fontWeight="regular"
                  color="text"
                >
                  Κατάσταση παρέμβασης
                </MDTypography>

                <Autocomplete
                  value={fields.status.find((s) => s.id === status) || null}
                  options={fields.status}
                  getOptionLabel={(option) => option.name}
                  onChange={(e, selectedOption) =>
                    handleInputChange("status", selectedOption)
                  }
                  renderInput={(params) => (
                    <MDInput {...params} variant="standard" />
                  )}
                />
                </Grid>
            
                {/* Position */}
                <Grid item xs={12} sm={12} container direction="column">
                  <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                    Θέση Παρέμβασης
                  </MDTypography>
                  {!position && (
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Επέλεξε Θέση στο Χάρτη
                    </MDTypography>
                  )}
                  {position && (
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Lat: {position[0]}
                    </MDTypography>
                  )}
                  {position && (
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Long: {position[1]}
                    </MDTypography>
                  )}
                </Grid>


                {/* NEW: Cluster dropdown (from JSON, label=name-id, value=id) */}
                <Grid item xs={12}>
                  <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                    Cluster
                  </MDTypography>
                  <Autocomplete
                    value={
                      clusterOptions.find((o) => String(o.id) === String(cluster)) || null
                    }
                    options={clusterOptions}
                    getOptionLabel={(option) => option.name}
                    onChange={(e, selectedOption) => handleInputChange("cluster", selectedOption)}
                    renderInput={(params) => (<MDInput {...params} variant="standard" />)}
                  />
                </Grid>

                {/* Description at the end (optional) */}
                <Grid item xs={12} sm={12}>
                  <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Σύντομη Περιγραφή/Παρατηρήσεις
                    </MDTypography>
                  </MDBox>
                  <MDEditor
                    value={description || ""} // Prevents undefined issues
                    onChange={(e) => handleInputChange('description', e)} // Uses the same handler
                  />
                </Grid>

                {/* Submit */}
                <Grid mt={3} item xs={12} sm={12}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDBox display="flex" alignItems="center">
                      <input
                        type="file"
                        accept=".pdf"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                      />
                      <MDButton
                        variant="contained"
                        color="warning"
                        onClick={handleImportClick}
                        sx={{ "&.MuiButton-contained": { textTransform: "capitalize !important" } }}
                      >
                        Ανέβασμα PDF
                      </MDButton>
                      <span style={{ marginLeft: "10px" }}>{fileName}</span>
                    </MDBox>

                    <MDButton
                      variant="gradient"
                      color="info"
                      onClick={handleSubmit}
                      sx={{ "&.MuiButton-contained": { textTransform: "capitalize !important" } }}
                    >
                      Καταχώρηση
                    </MDButton>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={7}>
          <div className='mapContainer100'>
            <MapSelect
              selectedPoint={position}
              setSelectedPoint={setPosition}
              clusterName={cluster}          // passes selected id
              setClusterName={setCluster}     // keep compatibility with MapSelect
            />
          </div>
        </Grid>
        {successSB && bringSuccessNotification()}
        {errorSB && bringErrorNotification()}
      </Grid>
    </DashboardLayout>
  );
};

export default Interventions;
